import React, { useState } from "react";
import { ReactComponent as Checked } from "../assets/analyse/Checked.svg";

function MainButton(props) {
  const [loading, setLoading] = useState(false);
  return (
    <button
      disabled={props.success ? true : !props.disabled}
      onClick={async (e) => {
        e.preventDefault();
        setLoading(true);
        await props.callback();
        setLoading(false);
      }}
      //   className={props.styleWind}
      className={
        props.styleWind +
        (!props.disabled ? " bg-[#BDC4CB] " : " bg-mainGreen focus:bg-blue-500 hover:bg-blue-500 ") +
        (props.success ? " bg-mainGreen " : " ") +
        " inline-flex items-center justify-center w-full h-full text-sm font-semibold leading-6 text-white transition duration-150 ease-in-out rounded-lg shadow focus:ring-2 "
      }
    >
      {
        loading ? (
          <svg className={"w-5 h-5 text-white animate-spin"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        ) : (
          <>
            {props.success ? (
              <>
                <Checked height={30} />
              </>
            ) : (
              <p className="font-Poppins-SemiBold">{props.title}</p>
            )}
          </>
        )
        // {props.success && {
      }
    </button>
  );
}

export default MainButton;
